/* eslint-disable quote-props */
/* eslint-disable no-cond-assign */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable @typescript-eslint/semi */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from 'src/app/global';
import { UserApiService } from 'src/app/services/user-api.service';
import { LocalStorageService } from 'src/app/services/core/local-storage.service';
@Component({
  selector: 'app-add-review',
  templateUrl: './add-review.page.html',
  styleUrls: ['./add-review.page.scss'],
})
export class AddReviewPage implements OnInit {
  rating=0;
  udid: string;
  email: string;
  description=''

  constructor( private modalController:ModalController,
    public globals:GlobalVariable,
    public server:UserApiService,
    private localStorageService:LocalStorageService) {
      this.udid= this.localStorageService.getUdId('UdId')
      this.email=this.localStorageService.getEmail('Email')
   }

  ngOnInit() {
  }

  changeRating(event){
    this.rating=event;
    console.log(this.rating)
  }
  save() {
    if(this.rating==0){
      this.globals.presentToast("Why not select rating first");
    }
    else{
      this.server.AddUserReview(this.email,this.description,this.rating).subscribe(data=>{
        console.log(data)
        if(data.status="Review added"){
          this.globals.presentToast("thanks for your feedback. your review hass been added. keep exploring");
          this.modalController.dismiss();
        }
      },err=>{
        this.globals.presentToast("failed to add")
      })
    }

}
  closeModel() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}
